import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../utils/axiosInstance";
// Async thunk for merging donors
export const mergeDonors = createAsyncThunk(
  "donorMerge/mergeDonors",
  async (mergePayload, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState();

      const response = await axiosInstance.post(
        "/api/donors/merge",
        mergePayload, // 👈 body ONLY
        {
          headers: {
            Authorization: `Bearer ${auth.token}`, // 👈 headers go here
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to merge donors"
      );
    }
  }
);


// Async thunk for getting donor merge preview
export const getDonorMergePreview = createAsyncThunk(
  "donorMerge/getDonorMergePreview",
  async ({ sourceDonorId, targetDonorId }, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState();
      const response = await axiosInstance.get(`/api/donors/merge-preview`, {
        params: { sourceDonorId, targetDonorId },
        headers: { Authorization: `Bearer ${auth.token}` },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to get merge preview"
      );
    }
  }
);

const donorMergeSlice = createSlice({
  name: "donorMerge",
  initialState: {
    loading: false,
    mergeResult: null,
    mergePreview: null,
    error: null,
    success: false,
  },
  reducers: {
    clearMergeResult: (state) => {
      state.mergeResult = null;
      state.error = null;
      state.success = false;
    },
    clearMergePreview: (state) => {
      state.mergePreview = null;
      state.error = null;
    },
    resetMergeState: (state) => {
      state.loading = false;
      state.mergeResult = null;
      state.mergePreview = null;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Merge donors
      .addCase(mergeDonors.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(mergeDonors.fulfilled, (state, action) => {
        state.loading = false;
        state.mergeResult = action.payload;
        state.success = true;
        state.error = null;
      })
      .addCase(mergeDonors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
        state.mergeResult = {
          success: false,
          message: action.payload,
        };
      })
      // Get merge preview
      .addCase(getDonorMergePreview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDonorMergePreview.fulfilled, (state, action) => {
        state.loading = false;
        state.mergePreview = action.payload;
        state.error = null;
      })
      .addCase(getDonorMergePreview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.mergePreview = null;
      });
  },
});

export const { clearMergeResult, clearMergePreview, resetMergeState } = donorMergeSlice.actions;
export default donorMergeSlice.reducer;